import { Routes } from '@angular/router';

import { WidgetFeature } from './state';
import { provideState } from '@ngrx/store';
import { WidgetEffects } from './state/effects';
import { provideEffects } from '@ngrx/effects';

import { MainComponent } from './components/main/main.component';
import { PricesComponent } from './components/prices/prices.component';
import { CommentsComponent } from './components/comments/comments.component';
import { OtaDetailsComponent } from './components/otaDetails/otaDetails.component';
import { SearchDispoComponent } from './components/searchDispo/searchDispo.component';
import { CaptureDetailComponent } from './components/captureDetail/captureDetail.component';
import { OtaPricesComponent } from './components/otaPrices/otaPrices.component';

// export const keyGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
//   console.log(state);
  
//   return of(true);
// };


export const routes: Routes = [
  {
    path: ':widgetKey',
    providers: [
      provideState(WidgetFeature.name, WidgetFeature.reducer),
      provideEffects(WidgetEffects),
    ],
    component: MainComponent,
    // canActivateChild: [keyGuard],
    children: [
      { path: '', redirectTo: 'prices', pathMatch: 'full' },
      {
        path: 'prices',
        component: PricesComponent,
        children: [
          { path: '', redirectTo: 'search', pathMatch: 'full' },
          {
            path: 'search',
            component: SearchDispoComponent,
            children: [
              { path: '', redirectTo: 'ota', pathMatch: 'full' },
              {
                path: 'snapshots',
                component: OtaDetailsComponent
              },
              {
                path: 'ota',
                component: OtaPricesComponent
              }
            ]
          }
        ]
      },
      {
        path: 'comments',
        component: CommentsComponent
      },
      {
        path: 'snapshot',
        component: CaptureDetailComponent
      }
    ]
  },
];
